import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import { FAMILY_KEY, PROGRAM_KEY } from '../../constants/common'
import { getSessionId } from '../../utils/helper'

export class ApplicationsService {
  async downloadFiles(programId, type) {
    try {
      const response = await service.get(Urls.getApiUrl(`application/view/${programId}`, MICROSERVICES.ENROLLMENTMANAGER), { params: { program_file_key: type } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllApplications(programId, page_no, page_size, filter_status, program) {
    const sendInParams = program && program[0] && program[0].family_key
    const params = { ...(sendInParams && { program_ids: programId }), page_no, page_size, filter_status }
    try {
      const response = await service.get(Urls.getApiUrl(`application/all/view${!sendInParams ? '/' + programId : ''}`, MICROSERVICES.ENROLLMENTMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getApplicationById(programId, applicationId) {
    const params = { programId }
    try {
      const response = await service.get(Urls.getApiUrl(`application/${applicationId}`, MICROSERVICES.ENROLLMENTMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllProgramIds(programId, intakePortalOnly) {
    const params = { programId, intakePortalOnly }
    try {
      const response = await service.get(Urls.getApiUrl(`programs/family`, MICROSERVICES.PROGRAMMANAGER), { headers: { 'e-auth-token': getSessionId() }, params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitNewApplication(programId, values, method = 'post', applicationId) {
    let formData = new FormData()
    const payload = {
      homeowner_info: {
        first_name: values.firstName,
        last_name: values.lastName,
        email_address: values.email,
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        state: values.state,
        zip: values.zip,
        phone: values.phone,
        encharge3: values.encharge3,
        encharge10: values.encharge10,
        program_type: values.programOptions,
        electric_account_number: values.ean,
        kw_capacity_committed: ((1.28 * values.encharge3) + (3.84 * values.encharge10)).toFixed(2)
      },
      ...(method === 'post' ? {
        source_portal: 'INTAKE',
        program_id: programId
      } : {})
    }
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    formData.append('application_form', blob)
    formData.append('tandc_form', values.energyHubTnc ? values.energyHubTnc : new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('enrollment_form', new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form1', new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form2', new Blob([], {
      type: 'multipart/form-data',
    }))
    try {
      const response = await service[method](Urls.getApiUrl(`application/${method === 'post' ? 'add' : applicationId + '/update'}`, MICROSERVICES.ENROLLMENTMANAGER), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitSiteId(applicationId, siteId) {
    try {
      const response = await service.put(Urls.getApiUrl(`application/${applicationId}/site/${siteId}`, MICROSERVICES.ENROLLMENTMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getDynamicForms(programKey) {
    try {
      const response = await service.get(Urls.getApiUrl(`application/dynamic-form/${programKey}`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async submitNewEnrollment(programId, formValues, method = 'post', applicationId, familyKey, programKey) {
    let formData = new FormData()
    const { payment_method, ...values } = formValues
    const payload = {
      homeowner_info: {
        ...values,
        ...(values.address2 ? values.address2 : { address2: null }),
        ...{ program_type: 'DISPATCH' }
      },
      ...(method === 'post' ? {
        source_portal: 'INTAKE',
        program_id: programId,
        site_id: values.site_id,
        ...(familyKey && familyKey === FAMILY_KEY.CT_ESS ? {
          pto: values.pto,
          event_incentive_category: values.event_incentive_category
        } : {}),
        ...(programKey && programKey === PROGRAM_KEY.GMP_BYOD ? {
          payment_method: formValues.payment_method
        } : {})
      } : {
        site_id: values.site_id,
        ...(familyKey && familyKey === FAMILY_KEY.CT_ESS ? {
          pto: values.pto,
          program_id: programId,
          event_incentive_category: values.event_incentive_category
        } : {}),
        ...(programKey && programKey === PROGRAM_KEY.GMP_BYOD ? {
          payment_method: formValues.payment_method
        } : {})
      })
    }
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    formData.append('application_form', blob)
    formData.append('tandc_form', values.tandc_form ? values.tandc_form : new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('enrollment_form', values.enrollment_form ? values.enrollment_form : new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form1', values.signed_form1 ? values.signed_form1 : new Blob([], {
      type: 'multipart/form-data',
    }))
    formData.append('signed_form2', new Blob([], {
      type: 'multipart/form-data',
    }))
    try {
      const response = await service[method](Urls.getApiUrl(`application/${method === 'post' ? 'new' : applicationId}`, MICROSERVICES.ENROLLMENTMANAGER), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const applicationsService = new ApplicationsService()
